import { Text, Platform } from 'react-native';
import { FontLoader } from 'qunar-react-native';

if(process.env.RUNTIME_ENV !== 'wechat'){
    FontLoader.loadFontSet(require('../assets/QFontSet'));
}

// 禁止字体缩放
// Text.defaultProps.allowFontScaling = false;
Text.defaultProps = {...(Text.defaultProps||{}),allowFontScaling:false};

// hybirdId头
global.accessibilityLabelPrefixOrder = 'commonbusiness_rn|order|';
// 标签集合对象
global.orderAccessibilityLabelName = {
    ORDER_TAB: global.accessibilityLabelPrefixOrder + "order_tab", //全部订单tab
    FILTER_ALL: global.accessibilityLabelPrefixOrder + "filter|all", //筛选栏-全部
    FILTER_FLIGHT: global.accessibilityLabelPrefixOrder + "filter|flight", //筛选栏-机票
    FILTER_HOTEL: global.accessibilityLabelPrefixOrder + "filter|hotel", //筛选栏-酒店住宿
    FILTER_BUS: global.accessibilityLabelPrefixOrder + "filter|bus", //筛选栏-汽车票
    FILTER_TRAIN: global.accessibilityLabelPrefixOrder + "filter|train", //筛选栏-火车票
    FILTER_TICKET: global.accessibilityLabelPrefixOrder + "filter|ticket", //筛选栏-门票
    FILTER_GROUP: global.accessibilityLabelPrefixOrder + "filter|group", //筛选栏-团购
    FILTER_CAR: global.accessibilityLabelPrefixOrder + "filter|car", //筛选栏-专车
    FILTER_TRAVEL: global.accessibilityLabelPrefixOrder + "filter|travel", //筛选栏-度假
    FILTER_VISA: global.accessibilityLabelPrefixOrder + "filter|visa", //筛选栏-签证
    FILTER_LOCAL: global.accessibilityLabelPrefixOrder + "filter|local", //筛选栏-惠玩当地
    FILTER_QMALL: global.accessibilityLabelPrefixOrder + "filter|qmall", //筛选栏-旅行商城
    FILTER_SHOPPING: global.accessibilityLabelPrefixOrder + "filter|shopping", //筛选栏-全球购
    FILTER_PACK: global.accessibilityLabelPrefixOrder + "filter|pack", //筛选栏-行李寄送
    FILTER_QSTAR: global.accessibilityLabelPrefixOrder + "filter|qstar", //筛选栏-行李寄送
    QUERY_MOBILE: global.accessibilityLabelPrefixOrder + "query_mobile", //手机查单
    KEFU: global.accessibilityLabelPrefixOrder + "kefu", //客服按钮
    CARD_DELETE: global.accessibilityLabelPrefixOrder + "card|delete", //删除订单
    TAB_ALL: global.accessibilityLabelPrefixOrder + "tab|all", //订单-全部tab
    TAB_NO_PAY: global.accessibilityLabelPrefixOrder + "tab|no_pay", //订单-待付款tab
    TAB_READY_GO: global.accessibilityLabelPrefixOrder + "tab|ready_go", //订单-待出行tab
    TAB_NO_COMMENT: global.accessibilityLabelPrefixOrder + "tab|no_comment", //订单-待点评tab
    TAB_REFUND: global.accessibilityLabelPrefixOrder + "tab|refund", //订单-退款单tab
    TAB_NO_TICKETED: global.accessibilityLabelPrefixOrder + "tab|no_ticketed", //订单-待出票tab
    TAB_READY_TICKETED: global.accessibilityLabelPrefixOrder + "tab|ready_ticketed", //订单-已出票tab
    TAB_REFUND_CHANGED: global.accessibilityLabelPrefixOrder + "tab|refund_changed", //订单-退改单tab
    FLIGHT_DEP_CITY: global.accessibilityLabelPrefixOrder + "flight|city", //机票-出发城市
    FLIGHT_ARR_CITY: global.accessibilityLabelPrefixOrder + "flight|arr_city", //机票-到达城市
    FLIGHT_FLIGHTNO: global.accessibilityLabelPrefixOrder + "flight|flightno", //机票-航班号
    FLIGHT_DEP_DATE: global.accessibilityLabelPrefixOrder + "flight|dep_date", //机票-出发日期
    HOTEL_TITLE: global.accessibilityLabelPrefixOrder + "hotel|title", //酒店-名称
    HOTEL_CHECK_IN: global.accessibilityLabelPrefixOrder + "hotel|check_in", //酒店-入住日期
    HOTEL_CHECK_OUT: global.accessibilityLabelPrefixOrder + "hotel|check_out", //酒店-离店日期
    HOTEL_ROOM_INFO: global.accessibilityLabelPrefixOrder +  "hotel|room_info", //酒店-房型信息
    TICKET_TITLE: global.accessibilityLabelPrefixOrder + "ticket|title", //门票-名称
    TICKET_COUNT: global.accessibilityLabelPrefixOrder + "ticket|count", //门票-数量
    TICKET_VALID_TIME: global.accessibilityLabelPrefixOrder + "ticket|valid_time", //门票-有效期
    TRAIN_DEP_STATION: global.accessibilityLabelPrefixOrder + "train|station", //火车票-出发站
    TRAIN_ARR_STATION: global.accessibilityLabelPrefixOrder + "train|arr_station", //火车票-到达站
    TRAIN_DEP_DATE: global.accessibilityLabelPrefixOrder + "train|dep_date", //火车票-出发日期
    TRAIN_TRAIN_NO: global.accessibilityLabelPrefixOrder + "train|train_no", //火车票-车次号
    CARD_CARD_TITLE: global.accessibilityLabelPrefixOrder + "card|card_title", //订单卡片左上角标题
    CARD_PRICE: global.accessibilityLabelPrefixOrder + "card|price", //订单价格
    CARD_STATUS: global.accessibilityLabelPrefixOrder + "card|status", //订单状态
    CARD_BTN: global.accessibilityLabelPrefixOrder + "card|btn_", //position按照卡片位置取值，如0，1,2,3
    CARD_REFUND_PROCESS: global.accessibilityLabelPrefixOrder + "card|refund_process", //退款进度
    CARD_KEFU: global.accessibilityLabelPrefixOrder + "card|kefu", //订单卡片-客服按钮
    CARD_PROBLEM_BTN: global.accessibilityLabelPrefixOrder + "card|problem_btn_", //快捷按钮，position按照卡片位置取值，如0，1,2,
    BTN_LOGIN_1: global.accessibilityLabelPrefixOrder + "btn_login_1", // 登录按钮1
    BTN_LOGIN: global.accessibilityLabelPrefixOrder + "btn_login", // 登录按钮2
    SHARE_ALERT: global.accessibilityLabelPrefixOrder + "share_alert", //订单-共享弹窗
    BIND_ALERT: global.accessibilityLabelPrefixOrder + "bind_alert", //订单-绑定弹窗
    UN_BIND: global.accessibilityLabelPrefixOrder + "un_bind", //订单-待绑定提示条
    WECHAT_BIND: global.accessibilityLabelPrefixOrder + "wechat|bind", //订单-微信绑定
};
// 标签跨平台生成函数
global.orderAccessibilityLabel = (accessibilityStr, label = undefined) => {
    if (!accessibilityStr) {
        return undefined;
    }
    let accesslabProps: any = {accessible: false};
    if (Platform.OS === 'ios') {
        accesslabProps.testID = accessibilityStr;
        if (label) {
            accesslabProps.accessibilityLabel = label;
        }
    } else {
        accesslabProps.testID = undefined;
        accesslabProps.accessibilityLabel = accessibilityStr;
    }
    return accesslabProps;
};
